import React, { useEffect, useState } from 'react'

import htmr from 'htmr'
import PropTypes from 'prop-types'
import styled from 'styled-components'

// Styles
import { colors, space } from '../../style/design-system'
// Utils
import footnoteState from '../../utils/footnoteState'

const Footnotes = ({ className }) => {
  // footnotes empty on render
  const [notes, setNotes] = useState([])
  const [includesBlsCitation, setHasBlsCitation] = useState(false)

  useEffect(() => {
    // When the component mounts, grab the footnotes and
    // store them in local state. This will force a re-render.
    setNotes(footnoteState.getFootnotes())

    // When the component unmounts, reset the global footnote
    // state and force a re-render.
    return () => {
      setNotes([])
    }
  }, [setNotes])

  useEffect(() => {
    const notesArr = [...notes]
    const hasBls = !!notesArr.find((note) => note.content.includes('Bureau of Labor Statistics'))
    setHasBlsCitation(hasBls)
  }, [notes])

  if (notes && notes.length > 0) {
    return (
      <div className={`section--footnotes ${className} my-10`}>
        <div className="container">
          <p className="h4 mt-0">
            <small>Citations</small>
          </p>
          <ul className="list-style-none">
            {notes.map((note) => (
              <li key={note.id}>
                <small>
                  <sup>{`${note.id} `}</sup>
                  {note.content && htmr(note.content)}
                  {note.link && (
                    <a href={note.link} target="_blank" rel="noopener noreferrer">
                      {` ${note.link}`}
                    </a>
                  )}
                </small>
              </li>
            ))}
            {includesBlsCitation && (
              <li className="ti-0">
                <small>
                  Where national data regarding earnings or employability within a particular field are cited,
                  individual readers should take note that national averages may not accurately reflect the earnings of
                  workers in their particular part of the country, and may include earners at all stages of their
                  career, not just entry-level wages for recent&nbsp;graduates.
                </small>
              </li>
            )}
          </ul>
        </div>
      </div>
    )
  }

  return null
}

Footnotes.propTypes = {
  className: PropTypes.string,
}

Footnotes.defaultProps = {
  className: undefined,
}

export default styled(Footnotes)`
  line-height: 0.9;
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  li {
    margin-bottom: ${space.d};
    margin-left: 11px;
    text-indent: -8px;
    word-wrap: break-word;
    &.ti-0 {
      text-indent: 0;
    }
  }
  .h4 {
    color: ${colors.dev.gray.b()};
  }
`
